import { IGetAllObraArquivoUseCase } from "../../../presentation/useCases/read/get_all_obra_arquivo_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { ObraArquivo } from "../../models/obra_arquivo";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllObraArquivoUseCase
 */

export class GetAllObraArquivoUseCase extends BasePaginatedUseCase<ObraArquivo> implements IGetAllObraArquivoUseCase {
  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async getAllObraArquivo(
    idObra: number | undefined,
    status: number | null,
    situacao: number | null,
    nomeDescricao: string | null,
    dataVencimento: (Date | null)[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idObra === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository.getAllObraArquivo(
      idObra,
      status,
      situacao,
      nomeDescricao,
      dataVencimento,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
